import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { FileQuestion } from "lucide-react";

const NotFound = () => {
  const handleHomePageClick = () => {
    window.location.href = "/invoices";
  };

  return (
    <div className="h-screen w-full flex items-center justify-center pb-44">
      <Card className="w-full max-w-md mx-4 animate-fade-up shadow">
        <CardContent className="pt-6">
          <div className="flex flex-col items-center text-center space-y-6">
            {/* Animated Icon */}
            <div className="rounded-full bg-slate-100 p-4 animate-bounce hover:bg-slate-200 transition-colors duration-300">
              <FileQuestion className="w-12 h-12 text-slate-600 animate-pulse" />
            </div>

            {/* Large 404 text with floating animation */}
            <div className="space-y-2 animate-float">
              <h1 className="text-7xl font-bold text-slate-900 hover:scale-105 transition-transform duration-300">
                4<span className="inline-block animate-bounce-slow">0</span>4
              </h1>
              <h2 className="text-2xl font-semibold text-slate-800 animate-fade-in">
                Page Not Found
              </h2>
            </div>

            {/* Description with fade-in animation */}
            <p
              className="text-slate-600 max-w-sm animate-fade-in opacity-0"
              style={{
                animationDelay: "0.5s",
                animationFillMode: "forwards",
              }}
            >
              The page you're looking for doesn't exist or has been moved to
              another URL.
            </p>

            {/* Action buttons with hover effects */}
            <div
              className="flex gap-4 animate-fade-in opacity-0"
              style={{
                animationDelay: "0.7s",
                animationFillMode: "forwards",
              }}
            >
              <Button
                variant="outline"
                onClick={() => window.history.back()}
                className="text-slate-600 hover:scale-105 transition-transform duration-300"
              >
                Go Back
              </Button>
              <Button
                onClick={handleHomePageClick}
                className="bg-slate-900 text-white hover:bg-slate-800 hover:scale-105 transition-all duration-300"
              >
                Home Page
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

// Add custom animations using keyframes
const style = document.createElement("style");
style.textContent = `
  @keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
  
  @keyframes bounce-slow {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-5px); }
  }
  
  @keyframes fade-up {
    0% { opacity: 0; transform: translateY(20px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes fade-in {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  
  .animate-float {
    animation: float 6s ease-in-out infinite;
  }
  
  .animate-bounce-slow {
    animation: bounce-slow 2s ease-in-out infinite;
  }
  
  .animate-fade-up {
    animation: fade-up 0.8s ease-out;
  }
  
  .animate-fade-in {
    animation: fade-in 0.8s ease-out;
  }
`;
document.head.appendChild(style);

export default NotFound;
